import { dbReducer, ReduxFind, insert, removeMany } from '@weblite/persist'
import { PendingMessage } from './types'

const COLLECTION = 'pendingMessages'

export const pendingMessagesStorage = {
  getAll(): PendingMessage[] {
    return ReduxFind(COLLECTION, {})
  },

  deleteMany(ids: string[]) {
    return removeMany(COLLECTION)(ids)
  },

  insert(messages: PendingMessage[]) {
    insert(COLLECTION)(messages)
  },
}

export const pendingMessagesReducer = dbReducer(['main', COLLECTION])
